// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file logger/options.proto (package logger, syntax proto3)
/* eslint-disable */
import { enumDesc, extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";
/**
 * Describes the file logger/options.proto.
 */
export const file_logger_options = /*@__PURE__*/ fileDesc("ChRsb2dnZXIvb3B0aW9ucy5wcm90bxIGbG9nZ2VyKlcKC1NlbnNpdGl2aXR5EhsKF1NFTlNJVElWSVRZX1VOU1BFQ0lGSUVEEAASEwoPU0VOU0lUSVZJVFlfUElJEAESFgoSU0VOU0lUSVZJVFlfU0VDUkVUEAI6QwoNcmVkYWN0X2Zvcm1hdBIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYhgogASgJUgxyZWRhY3RGb3JtYXQ6MgoEbmFtZRIdLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE9wdGlvbnMYhwogASgJUgRuYW1lOlUKC3NlbnNpdGl2aXR5Eh0uZ29vZ2xlLnByb3RvYnVmLkZpZWxkT3B0aW9ucxiICiABKA4yEy5sb2dnZXIuU2Vuc2l0aXZpdHlSC3NlbnNpdGl2aXR5Qk1aKmdpdGh1Yi5jb20vbGl2ZWtpdC9wcm90b2NvbC9saXZla2l0L2xvZ2dlcqoCDUxpdmVLaXQuUHJvdG/qAg5MaXZlS2l0OjpQcm90b2IGcHJvdG8z", [file_google_protobuf_descriptor]);
/**
 * @generated from enum logger.Sensitivity
 */
export var Sensitivity;
(function (Sensitivity) {
    /**
     * Unannotated default — safe to log.
     * Identifiers, IDs, timestamps, enums, status fields.
     *
     * @generated from enum value: SENSITIVITY_UNSPECIFIED = 0;
     */
    Sensitivity[Sensitivity["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * User-identifying or user-controlled data: display names, phone numbers,
     * metadata, attributes, custom headers, auth usernames, semi-public account
     * identifiers (AWS role ARNs, Azure account names).
     * Recorded under a sensitivity tag by a sink that can tag; redacted by one
     * that cannot.
     *
     * @generated from enum value: SENSITIVITY_PII = 1;
     */
    Sensitivity[Sensitivity["PII"] = 1] = "PII";
    /**
     * Credentials and authentication material: passwords, access keys, session
     * tokens, signing keys, API keys, ICE credentials.
     * ALWAYS redacted: no sink may record it.
     *
     * @generated from enum value: SENSITIVITY_SECRET = 2;
     */
    Sensitivity[Sensitivity["SECRET"] = 2] = "SECRET";
})(Sensitivity || (Sensitivity = {}));
/**
 * Describes the enum logger.Sensitivity.
 */
export const SensitivitySchema = /*@__PURE__*/ enumDesc(file_logger_options, 0);
/**
 * @generated from extension: string redact_format = 1286;
 */
export const redact_format = /*@__PURE__*/ extDesc(file_logger_options, 0);
/**
 * @generated from extension: string name = 1287;
 */
export const name = /*@__PURE__*/ extDesc(file_logger_options, 1);
/**
 * @generated from extension: logger.Sensitivity sensitivity = 1288;
 */
export const sensitivity = /*@__PURE__*/ extDesc(file_logger_options, 2);
